import reset from 'styled-reset'
import { css } from 'styled-components'

import { spacingToken } from './tokens'

// @therich-team/design-system v0.1.36 src/style/reset.ts 그대로
export default css`
  ${reset}

  * {
    outline: none;
  }

  a {
    text-decoration: none;
  }

  h2 {
    margin-block-start: 0;
    margin-block-end: 0;
  }

  input {
    border: 0;
    padding: 0;
    margin: 0;
  }

  input[type='checkbox'],
  input[type='radio'] {
    :disabled {
      + span {
        cursor: not-allowed;
      }
    }
  }

  input[type='radio'] + label,
  button {
    margin: 0;
    padding: 0;
    border: 0;
    background-color: transparent;
    cursor: pointer;
    background: none;
    padding: 0;
    :disabled {
      cursor: not-allowed;
    }
  }

  /* Change Autocomplete styles in Windows Chrome*/
  input:-webkit-autofill,
  input:-webkit-autofill:hover,
  input:-webkit-autofill:focus,
  textarea:-webkit-autofill,
  textarea:-webkit-autofill:hover,
  textarea:-webkit-autofill:focus,
  select:-webkit-autofill,
  select:-webkit-autofill:hover,
  select:-webkit-autofill:focus {
    border: 1px solid var(--color-primary);
    -webkit-text-fill-color: var(--color-primary);
    -webkit-box-shadow: 0 0 0px 1000px #000 inset;
    transition: background-color 5000s ease-in-out 0s;
  }

  /* safari input zoom disabled */
  @media screen and (max-width: 767px) and (device-aspect-ratio: 9/16) {
    select,
    textarea,
    input[type='text'],
    input[type='password'],
    input[type='datetime'],
    input[type='datetime-local'],
    input[type='date'],
    input[type='month'],
    input[type='time'],
    input[type='week'],
    input[type='number'],
    input[type='email'],
    input[type='tel'],
    input[type='url'] {
      font-size: 16px;
    }
  }

  /* safari selectbox reset */
  select {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    /* SVG background image */
    background: blue
      url('data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI5IiBoZWlnaHQ9IjYiIHZpZXdCb3g9IjAgMCA5IDYiPgogICAgPGcgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4KICAgICAgICA8ZyBmaWxsPSIjRkVGRUZFIj4KICAgICAgICAgICAgPGc+CiAgICAgICAgICAgICAgICA8Zz4KICAgICAgICAgICAgICAgICAgICA8cGF0aCBkPSJNNjMuNSAyMkw2OCAyOCA1OSAyOHoiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC05MS4wMDAwMDAsIC0zNTguMDAwMDAwKSB0cmFuc2xhdGUoMzIuMDAwMDAwLCAzMDEuMDAwMDAwKSB0cmFuc2xhdGUoMC4wMDAwMDAsIDM1LjAwMDAwMCkgdHJhbnNsYXRlKDYzLjUwMDAwMCwgMjUuMDAwMDAwKSByb3RhdGUoLTE4MC4wMDAwMDApIHRyYW5zbGF0ZSgtNjMuNTAwMDAwLCAtMjUuMDAwMDAwKSIvPgogICAgICAgICAgICAgICAgPC9nPgogICAgICAgICAgICA8L2c+CiAgICAgICAgPC9nPgogICAgPC9nPgo8L3N2Zz4K')
      no-repeat;
    background-size: 9px;
    background-position: calc(100% - ${spacingToken.withVar[100]}) center;
    background-repeat: no-repeat;
    background-color: #efefef;
    display: block;
    width: 100%;
    margin: 0;
    padding-right: ${spacingToken.withVar[600]};
  }

  input[type='date'] {
    display: block;
    -webkit-appearance: textfield;
    -moz-appearance: textfield;
    min-height: 1.4em;
  }

  /* hide input number arrow */
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  /* Firefox */
  input[type='number'] {
    -moz-appearance: textfield;
  }
`
